import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EFonts, EHovers } from 'libs/styles/styling';
import styled, { css } from 'styled-components/macro';

export interface OptionRowValueItem {
    iconName?: IconName;
    iconSet?: IconPrefix;
    text?: string;
    iconAlignment?: 'left' | 'right';
}

interface Props {
    items: OptionRowValueItem[];
    selectedIndex: number;
    onSelected?: (index: number) => void;
    className?: string;
}

export const OptionRowValue = (props: Props): JSX.Element => {
    return (
        <S_OptionRowValue className={props.className}>
            {props.items.map((item, index) => {
                const isSelected = props.selectedIndex === index;
                return (
                    <S_Item
                        key={item.iconName + (item.text ?? index)}
                        $selected={isSelected}
                        $notLast={index !== props.items.length - 1}
                        $reverseColumns={item.iconAlignment === 'left'}
                        onClick={() => {
                            if (!isSelected) {
                                props.onSelected?.(index);
                            }
                        }}
                    >
                        {item.iconName && (
                            <S_Icon
                                icon={[item.iconSet ?? 'fal', item.iconName]}
                                $selected={isSelected}
                            />
                        )}
                        {item.iconName && item.text && <S_Both />}
                        {item.text && <S_Text $selected={isSelected}>{item.text}</S_Text>}
                    </S_Item>
                );
            })}
        </S_OptionRowValue>
    );
};

const S_OptionRowValue = styled.div`
    width: 100%;
    height: 40px;
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 7px;
    border: 1px solid #dadada;
    overflow: hidden;
    user-select: none;
`;

const S_Item = styled.div<{
    $selected: boolean;
    $notLast: boolean;
    $reverseColumns: boolean;
}>`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: ${(props) => (props.$notLast ? '1px solid #dadada' : 'none')};
    position: relative;
    overflow: hidden;
    background: ${(props) => (props.$selected ? '#F4F4F4' : '#f5f5f5')};
    box-shadow: ${(props) => (props.$selected ? 'none' : '0px 0px 20px 0px #dedede inset')};
    cursor: ${(props) => (props.$selected ? 'default' : 'pointer')};
    flex-direction: ${(props) => (props.$reverseColumns ? 'row-reverse' : 'row')};
    ${(props) => {
        if (!props.$selected) {
            return css`
                &:hover {
                    box-shadow: ${EHovers.LIGHT4};
                }
            `;
        }
    }}
`;

const S_Text = styled.div<{ $selected: boolean }>`
    font-size: 13px;
    font-family: ${EFonts.Regular};
    padding: 0 4px;
    color: #141c54;
`;

const S_Icon = styled(FontAwesomeIcon)<{ $selected: boolean }>`
    font-size: 18px;
    width: 20px;
    color: #141c54;
`;

const S_Both = styled.div`
    width: 4px;
`;
